import { splitStringToNumber } from '@/helpers/ulti';
import { IRootState } from '@/store';
import { ActionContext, ActionTree } from 'vuex';
import {
    cancelSell,
    checkCanBuy,
    getListTokenPriceSellNft,
    checkCanBuyV2,
    checkout,
    checkoutMetamask,
    checkoutV2,
    firework,
    fireworkConfig,
    getCountNtf,
    getExpiredBuy,
    getCountryCodeInfo,
    getDetailNft,
    getDomain,
    getListBuyToken,
    getListItem,
    getListItemV2,
    getListMyCollection,
    getListMyCollectionMinted,
    getListMyCollectionNotMint,
    getTokenList,
    getToWallet,
    getTransaction,
    getTransactionV2,
    metamask,
    sellNft,
    transferNft,
    updatePrice,
} from '../services';

import { homeMutations, IHomeState } from './home';
import moment from 'moment';

// @ts-ignore
const homeAction: ActionTree<IHomeState, IRootState> = {
    // call list item
    async getListItem(context: ActionContext<IHomeState, IRootState>, params) {
        const response = await getListItem(params);
        if (response.success) {
            context.commit(homeMutations.SET_LIST_ITEM, response?.data.data);
        }
        return response.data;
    },
    async getListItemV2(context: ActionContext<IHomeState, IRootState>) {
        const response = await getListItemV2();
        if (response.success) {
            context.commit(homeMutations.SET_LIST_ITEM, response.data.map(item => {
                item.open_sell_at = moment.unix(item.open_sell_at).local().format('YYYY-MM-DD HH:mm:ss')
                return item
            }));
        }
        return response.data;
    },
    // call api count ntf
    async getCountNtf(context: ActionContext<IHomeState, IRootState>) {
        const response = await getCountNtf();
        if (response.success) {
            context.commit(
                homeMutations.SET_COUNT_NFT,
                splitStringToNumber(response?.data?.count),
            );
        }
        return response;
    },
    async getExpiredBuy(context: ActionContext<IHomeState, IRootState>) {
        const response = await getExpiredBuy();
        if (response.success) {
            context.commit(
                homeMutations.SET_EXPIRED_BUY_NFT,
                moment.unix(response.data.time).local().format('YYYY-MM-DD HH:mm:ss'),
            );
        }
        return response;
    },
    // call api my collection
    async getListMyCollectionNotMint(context: ActionContext<IHomeState, IRootState>, params) {
        const response = await getListMyCollectionNotMint(params);
        if (response.success) {
            context.commit(homeMutations.SET_LIST_MY_COLLECTION_NOT_MINT, response?.data);
        }
        return response.data;
    },

    async getListMyCollection(context: ActionContext<IHomeState, IRootState>) {
        const response = await getListMyCollection();
        if (response.success) {
            context.commit(homeMutations.SET_LIST_MY_COLLECTION, response?.data);
        }
        return response.data;
    },

    // call api my collection minted
    async getListMyCollectionMinted(context: ActionContext<IHomeState, IRootState>) {
        const response = await getListMyCollectionMinted();
        if (response.success) {
            context.commit(homeMutations.SET_LIST_MY_COLLECTION_MINTED, response?.data);
        }
        return response.data;
    },
    // call api detail nft
    async getDetailNft(context: ActionContext<IHomeState, IRootState>, id) {
        const response = await getDetailNft(id);
        return response;
    },
    // call api update price
    async updatePrice(context: ActionContext<IHomeState, IRootState>, item) {
        const response = await updatePrice(item.id, item.price);
        return response;
    },
    // call api sell nft
    async sellNft(context: ActionContext<IHomeState, IRootState>, item) {
        const response = await sellNft(item);
        return response;
    },

    // call api transaction
    async getTransaction(context: ActionContext<IHomeState, IRootState>, param) {
        const response = await getTransaction(param.type, param.pagination);
        return response;
    },
    async getTransactionV2(context: ActionContext<IHomeState, IRootState>, param) {
        return await getTransactionV2(param.pagination);
    },
    async getCountryCodeInfo() {
        const response = await getCountryCodeInfo();
        return response;
    },
    // call api get to wallet
    async getToWallet(context: ActionContext<IHomeState, IRootState>, id) {
        return await getToWallet(id);
    },
    async checkout(context: ActionContext<IHomeState, IRootState>, params) {
        return await checkout(params);
    },
    async checkoutV2(context: ActionContext<IHomeState, IRootState>, params) {
        return await checkoutV2(params);
    },
    async checkoutMetamask(context: ActionContext<IHomeState, IRootState>, params) {
        return await checkoutMetamask(params);
    },
    async cancelSell(context: ActionContext<IHomeState, IRootState>, params) {
        return await cancelSell(params);
    },
    async metamask(context: ActionContext<IHomeState, IRootState>, params) {
        return await metamask(params);
    },
    async getDomain(context: ActionContext<IHomeState, IRootState>) {
        return await getDomain();
    },
    async checkCanBuy(context: ActionContext<IHomeState, IRootState>, params) {
        return await checkCanBuy(params);
    },
    async checkCanBuyV2(context: ActionContext<IHomeState, IRootState>, params) {
        return await checkCanBuyV2(params);
    },
    async firework(context: ActionContext<IHomeState, IRootState>) {
        return await firework();
    },
    async fireworkConfig(context: ActionContext<IHomeState, IRootState>) {
        return await fireworkConfig();
    },
    async getListToken(context: ActionContext<IHomeState, IRootState>) {
        return await getTokenList();
    },
    async getListBuyToken(context: ActionContext<IHomeState, IRootState>) {
        return await getListBuyToken();
    },
    // call api sell nft
    async transferNft(context: ActionContext<IHomeState, IRootState>, item) {
        const response = await transferNft(item);
        return response;
    },

    async getListTokenPriceSellNft(context: ActionContext<IHomeState, IRootState>) {
        const response = await getListTokenPriceSellNft();
        if (response.success) {
            context.commit(homeMutations.SET_LIST_TOKEN_SELL, response?.data);
        }
        return response.data;
    },





};
export default homeAction;
